// PATH: src/components/IDEConsole/utils/executionBridge.ts
import { ConsoleOutput } from '../../Console/types';

export interface ExecutionBridge {
  onLog: (message: string) => void;
  onInfo?: (message: string) => void;
  onWarn?: (message: string) => void;
  onError: (error: string) => void;
  onComplete: () => void;
}

export class IDEConsoleBridge implements ExecutionBridge {
  private outputCallback: (output: ConsoleOutput[]) => void;
  private outputs: ConsoleOutput[] = [];

  constructor(outputCallback: (output: ConsoleOutput[]) => void) {
    this.outputCallback = outputCallback;
  }

  // Centralise l’ajout d’une ligne dans la console
  private push(type: ConsoleOutput['type'], message: string, data?: unknown) {
    const output: ConsoleOutput = {
      id: Date.now().toString(),
      type,
      message,
      timestamp: new Date(),
      ...(data !== undefined ? { data } : {}),
    };
    this.outputs.push(output);
    this.outputCallback([...this.outputs]);
  }

  // API standard utilisée par les adapters
  onLog = (message: string) => this.push('log', message);
  onInfo = (message: string) => this.push('info', message);
  onWarn = (message: string) => this.push('warn', message);
  onError = (error: string) => this.push('error', error);
  onComplete = () => {}; // Removed the "Code execution completed" message

  // Utilitaires
  clear = () => {
    this.outputs = [];
    this.outputCallback([]);
  };

  getOutputs = () => {
    return [...this.outputs];
  };
}

export { IDEConsoleBridge as default };
